import React, { type FC, useMemo } from 'react'
import { FormControlLabel, type SxProps, type Theme } from '@mui/material'

import type { CybusPermissionOperations } from '../../../../domain'

import { Checkbox } from '../../common'
import { useTranslatedOperationPermission } from '../Hooks'

const checkboxStyle: SxProps<Theme> = { py: 0 }

const OperationCheckbox: FC<{ title?: string, disabled?: boolean, checked: boolean, label: string, onChange: VoidFunction }> = ({
    disabled,
    checked,
    onChange,
    ...props
}) => (
    <FormControlLabel
        {...props}
        slotProps={{ typography: { variant: 'body2' } }}
        control={<Checkbox sx={checkboxStyle} size="small" disabled={disabled} checked={checked} onClick={onChange} />}
    />
)

export const OperationsList: FC<
    CybusPermissionOperations & {
        disabled?: boolean
        disabledRead?: boolean
        disabledWrite?: boolean
        readTitle?: string
        writeTitle?: string
        onChange: (operations: CybusPermissionOperations) => void
    }
> = ({ readTitle, writeTitle, disabled, disabledRead, disabledWrite, read, write, onChange }) => {
    const translate = useTranslatedOperationPermission()
    const [readLabel, writeLabel] = useMemo(() => [translate({ read: true, write: false }), translate({ read: false, write: true })], [translate])

    return (
        <>
            <OperationCheckbox
                data-testid="read-input"
                title={readTitle}
                disabled={disabled || disabledRead}
                checked={read}
                label={readLabel}
                onChange={() => onChange({ read: !read, write })}
            />
            <OperationCheckbox
                data-testid="write-input"
                title={writeTitle}
                disabled={disabled || disabledWrite}
                checked={write}
                label={writeLabel}
                onChange={() => onChange({ read, write: !write })}
            />
        </>
    )
}
